import { render, staticRenderFns } from "./PanelControls.vue?vue&type=template&id=fd80b0b0&scoped=true&"
import script from "./PanelControls.vue?vue&type=script&lang=js&"
export * from "./PanelControls.vue?vue&type=script&lang=js&"
import style0 from "./PanelControls.vue?vue&type=style&index=0&id=fd80b0b0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd80b0b0",
  null
  
)

export default component.exports